import { GameServices } from "game/GameServices";
import { View } from "@westpierstudio/luma/mvc";
import { Spine } from "pixi-spine";
import { addToSpineSlot, resetSpine } from "utils/Misc";
import { Signal } from "type-signals";
import { Text } from "pixi.js";
import { AdvancedText } from "@westpierstudio/luma/utils/advancedtext";
import { BoundedContainer } from "utils/BoundedContainer";
class BonusSummaryScrollSignals {
    bonusSummaryComplete = new Signal();
}

export class BonusSummaryScroll extends View {
    private readonly scroll: Spine;
    private readonly value: Text | AdvancedText;
    private readonly text: Text | AdvancedText;
    signals = new BonusSummaryScrollSignals();
    valueBounds: BoundedContainer;

    constructor(protected override services: GameServices) {
        super(services);

        const {factory, resources} = this.services;

        const spec = resources.getSpec(`bonussummaryscroll`);
        factory.applySpec(this, spec);

        this.scroll = factory.createSpine(spec.scroll, this);

        this.valueBounds = new BoundedContainer(spec.valueBounds);
        this.value = factory.createText(``, spec.scrollValue, this.valueBounds);
        this.text = factory.createText(resources.getMessage(`bonusSummaryScrollTotalWin`), spec.scrollText);

        addToSpineSlot(this.scroll, this.valueBounds, `dynamic_value`);
        addToSpineSlot(this.scroll, this.text, `dynamic_title`);

        this.visible = false;
    }

    show(money: number): void {

        this.value.text = this.services.currency.formatCoins(money, {group: true});
        this.valueBounds.update();

        this.visible = true;

        this.scroll.state.setAnimation(0, `summary-scroll`, false);
        this.scroll.state.addListener({ event: (_, event) => {

            if (event.data.name === `shutters-start`) {
                this.scroll.state.clearListeners();
                this.signals.bonusSummaryComplete.dispatch();
            }
        }});
    }

    override reset(): void {

        this.visible = false;
        resetSpine(this.scroll);
    }
}